const wpBlockGalleries = document.querySelectorAll('.wp-block-gallery');

if (wpBlockGalleries.length) {
    for (let g = 0; g < wpBlockGalleries.length; g++) {
        const gal = wpBlockGalleries[g];
        
        const galAnchors = gal.querySelectorAll('a');

        if(galAnchors.length) {
            for (let a = 0; a < galAnchors.length; a++) {
                const link = galAnchors[a];

                link.setAttribute('data-lightbox', 'cw-lb-set-' + g);
            }
        }
    }
}